export default __webpack_public_path__ + "static/media/image3.b90677f8.avif";